export default __webpack_public_path__ + "files/47bdae7ece4d324d6be2816887ceccdb.jpg";